/**
 * createHistoryRepository — platform factory.
 *
 * Selects the correct HistoryRepository implementation at runtime.
 * Mirrors the pattern of getPlatformDestinationProvider() in packages/platform/index.ts.
 *
 * The typeof window check is acceptable here: this IS the platform boundary.
 * The domain core and TransferCoordinator never see this check.
 *
 *   Web    → IDBHistoryRepository  (BitDrop/transfers IDB store)
 *   Native → SQLiteHistoryRepository (react-native-quick-sqlite)
 */

import type { HistoryRepository } from '@share/domain';

import { IDBHistoryRepository } from './database/idb-history-repository';
import { SQLiteHistoryRepository } from './database/sqlite-history-repository';

export function createHistoryRepository(): HistoryRepository {
  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    // Web runtime
    return new IDBHistoryRepository();
  }
  // Native runtime (iOS / Android)
  return new SQLiteHistoryRepository();
}
